import React from 'react';


export default function FieldDropdownViewInImport(customField, props) {

    // console.log("customField = ", customField);
    // console.log("props = ", props);

    return (
        <div className="ui5-pill-22 gray">
            {customField.getValueById(props.value)}
        </div>
    );
}